module.exports = __webpack_public_path__ + "img/logo_wfxrtv.d7df750f.png";